/* eslint-disable no-unused-vars */

/**
 * @fileOverview A convenience wrapper function for vanilla-lazyload.
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires NPM:vanilla_lazyload/dist/lazyload.es2015
 * @requires Polyfill:Element.prototype.classList
 */

import LazyLoad from 'vanilla-lazyload/dist/lazyload.es2015';

/**
 * @function lazyLoading
 * @description Check if lazy images exist in the document, if so, initialize
 *     a new LazyLoad instance.
 * @returns {(null|object)} Null if no lazy images are found, the LazyLoad
 *     instance used to initialize the images otherwise .
 */
export default function lazyLoading() {
  // Bail out if no lazy images are found.
  if ( document.querySelectorAll( '[data-src]' ).length ) {
    return new LazyLoad({
      elements_selector: '[data-src]',
      threshold: 160,
      class_loading: 'js-lazy--loading',
      class_loaded: 'js-lazy--loaded',
      class_error: 'js-lazy--error',
      callback_set: el => {
        el.classList.toggle( 'js-lazy--img-loading' );
      },
      callback_load: el => {
        el.classList.toggle( 'js-lazy--img-loading' );
      }
    });
  } else {
    return null;
  }
}

